export const DEFAULT_LANGUAGE = "en-US";
export const SUPPORTED_LANGUAGES = ["en-US", "es-ES", "fr-CA"];
export const CDN_URL = "https://storage.googleapis.com/translatefiles";
